module.exports = __webpack_public_path__ + "img/pic-2-1.8b27946c.png";